var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _defineProperty2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("@driftt/tide-icons"), require("ramda"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "@driftt/tide-icons", "ramda"], t);else {
    var r = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("@driftt/tide-icons"), require("ramda")) : t(e.react, e["@driftt/tide-core"], e["@driftt/tide-icons"], e.ramda);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r, n) {
  return function (e) {
    var t = {};

    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 6);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    e.exports = r(7)();
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      function r(n) {
        if (t[n]) return t[n].exports;
        var a = t[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
      }

      var t = {};
      return r.m = e, r.c = t, r.d = function (e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
          configurable: !1,
          enumerable: !0,
          get: n
        });
      }, r.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return r.d(t, "a", t), t;
      }, r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, r.p = "", r(r.s = 0);
    }([function (e, t, r) {
      "use strict";

      t.__esModule = !0, t.default = function (e, t) {
        if (e && t) {
          var r = Array.isArray(t) ? t : t.split(","),
              n = e.name || "",
              a = e.type || "",
              o = a.replace(/\/.*$/, "");
          return r.some(function (e) {
            var t = e.trim();
            return "." === t.charAt(0) ? n.toLowerCase().endsWith(t.toLowerCase()) : t.endsWith("/*") ? o === t.replace(/\/.*$/, "") : a === t;
          });
        }

        return !0;
      };
    }]);
  }, function (e, t, r) {
    var n;
    !function () {
      "use strict";

      var r = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var a = typeof n;
            if ("string" === a || "number" === a) e.push(n);else if (Array.isArray(n) && n.length) {
              var o = classNames.apply(null, n);
              o && e.push(o);
            } else if ("object" === a) for (var i in n) {
              r.call(n, i) && n[i] && e.push(i);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (n = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t, r) {
    e.exports = r(15);
  }, function (e, t, r) {
    "use strict";

    var n = r(8);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, r, a, o, i) {
        if (i !== n) {
          var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw l.name = "Invariant Violation", l;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, r) {
    var n = r(11);
    "string" === typeof n && (n = [[e.i, n, ""]]);
    var a = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    r(13)(n, a);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(12)(!0)).push([e.i, ".tide-upload-area-preview svg,\n.tide-upload-area-preview img {\n  cursor: pointer;\n  display: block;\n  height: 90%;\n  margin-bottom: 8px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tide-upload-area-placeholder,\n.tide-upload-area-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.tide-upload-area-preview-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tide-upload-area-preview-clear-link {\n  border: 0;\n  cursor: pointer;\n  margin-top: 8px;\n  padding: 0;\n}\n\n.tide-upload-area-preview-clear-link > .tide-text-span {\n  font-family: var(--main-font-family);\n}\n\n.tide-upload-area-loader-copy {\n  margin-top: -57px;\n}\n\n.tide-upload-area {\n  border: dashed 1px var(--color-p3-4);\n  border-radius: 3px;\n  width: 50%;\n  min-height: 165px;\n  height: 165px;\n  padding: 1rem;\n  text-align: center;\n  transition: linear .2s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative\n}\n\n.tide-upload-area .tide-input-wrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.tide-upload-area .tide-input-wrapper:focus {\n  outline: none;\n}\n\n.tide-upload-area.disabled,\n.tide-upload-area.disabled:hover,\n.tide-upload-area.disabled.empty:hover {\n  background: var(--color-p1-3);\n  border: dashed 1px var(--color-p3-3);\n  cursor: default;\n}\n\n.tide-upload-area .tide-ribbon--container {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n}\n\n.tide-upload-area.tide-upload-area.disabled .tide-upload-area-placeholder .tide-paragraph,\n.tide-upload-area.tide-upload-area.disabled .tide-upload-area-placeholder .tide-anchor-link {\n  color: var(--color-p1-6);\n  cursor: default;\n}\n\n.tide-upload-area.empty:hover{\n  transition: linear .2s;\n  border: dashed 1px var(--color-p3-4);\n  background-color: var(--color-p3-2);\n  cursor: pointer;\n}\n\n.tide-upload-area-placeholder-video,\n.tide-upload-area-placeholder-video-success,\n.tide-upload-area-placeholder-pdf,\n.tide-upload-area-success-pdf,\n.tide-upload-area-placeholder-csv,\n.tide-upload-area-success-csv,\n.tide-upload-area-image,\n.tide-upload-area-pem-doc,\n.tide-upload-area-xml-doc  {\n  margin: auto;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;;EAEE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;AACjB;;AAEA;;;;;;;;;EASE,YAAY;AACd",
      file: "style.css",
      sourcesContent: [".tide-upload-area-preview svg,\n.tide-upload-area-preview img {\n  cursor: pointer;\n  display: block;\n  height: 90%;\n  margin-bottom: 8px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tide-upload-area-placeholder,\n.tide-upload-area-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.tide-upload-area-preview-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tide-upload-area-preview-clear-link {\n  border: 0;\n  cursor: pointer;\n  margin-top: 8px;\n  padding: 0;\n}\n\n.tide-upload-area-preview-clear-link > .tide-text-span {\n  font-family: var(--main-font-family);\n}\n\n.tide-upload-area-loader-copy {\n  margin-top: -57px;\n}\n\n.tide-upload-area {\n  border: dashed 1px var(--color-p3-4);\n  border-radius: 3px;\n  width: 50%;\n  min-height: 165px;\n  height: 165px;\n  padding: 1rem;\n  text-align: center;\n  transition: linear .2s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative\n}\n\n.tide-upload-area .tide-input-wrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.tide-upload-area .tide-input-wrapper:focus {\n  outline: none;\n}\n\n.tide-upload-area.disabled,\n.tide-upload-area.disabled:hover,\n.tide-upload-area.disabled.empty:hover {\n  background: var(--color-p1-3);\n  border: dashed 1px var(--color-p3-3);\n  cursor: default;\n}\n\n.tide-upload-area .tide-ribbon--container {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n}\n\n.tide-upload-area.tide-upload-area.disabled .tide-upload-area-placeholder .tide-paragraph,\n.tide-upload-area.tide-upload-area.disabled .tide-upload-area-placeholder .tide-anchor-link {\n  color: var(--color-p1-6);\n  cursor: default;\n}\n\n.tide-upload-area.empty:hover{\n  transition: linear .2s;\n  border: dashed 1px var(--color-p3-4);\n  background-color: var(--color-p3-2);\n  cursor: pointer;\n}\n\n.tide-upload-area-placeholder-video,\n.tide-upload-area-placeholder-video-success,\n.tide-upload-area-placeholder-pdf,\n.tide-upload-area-success-pdf,\n.tide-upload-area-placeholder-csv,\n.tide-upload-area-success-csv,\n.tide-upload-area-image,\n.tide-upload-area-pem-doc,\n.tide-upload-area-xml-doc  {\n  margin: auto;\n}\n"]
    }]);
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var r = function cssWithMappingToString(e, t) {
            var r = e[1] || "",
                n = e[3];
            if (!n) return r;

            if (t && "function" === typeof btoa) {
              var a = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(n),
                  o = n.sources.map(function (e) {
                return "/*# sourceURL=" + n.sourceRoot + e + " */";
              });

              return [r].concat(o).concat([a]).join("\n");
            }

            return [r].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
        }).join("");
      }, t.i = function (e, r) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var n = {}, a = 0; a < this.length; a++) {
          var o = this[a][0];
          null != o && (n[o] = !0);
        }

        for (a = 0; a < e.length; a++) {
          var i = e[a];
          null != i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), t.push(i));
        }
      }, t;
    };
  }, function (e, t, r) {
    var n = {},
        a = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        o = function (e) {
      var t = {};
      return function (e, r) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var n = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, r);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (a) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        i = null,
        l = 0,
        c = [],
        s = r(14);

    function addStylesToDom(e, t) {
      for (var r = 0; r < e.length; r++) {
        var a = e[r],
            o = n[a.id];

        if (o) {
          o.refs++;

          for (var i = 0; i < o.parts.length; i++) {
            o.parts[i](a.parts[i]);
          }

          for (; i < a.parts.length; i++) {
            o.parts.push(addStyle(a.parts[i], t));
          }
        } else {
          var l = [];

          for (i = 0; i < a.parts.length; i++) {
            l.push(addStyle(a.parts[i], t));
          }

          n[a.id] = {
            id: a.id,
            refs: 1,
            parts: l
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var r = [], n = {}, a = 0; a < e.length; a++) {
        var o = e[a],
            i = t.base ? o[0] + t.base : o[0],
            l = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        n[i] ? n[i].parts.push(l) : r.push(n[i] = {
          id: i,
          parts: [l]
        });
      }

      return r;
    }

    function insertStyleElement(e, t) {
      var r = o(e.insertInto);
      if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var n = c[c.length - 1];
      if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), c.push(t);else if ("bottom" === e.insertAt) r.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var a = o(e.insertAt.before, r);
        r.insertBefore(t, a);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      t >= 0 && c.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var n = function getNonce() {
          0;
          return r.nc;
        }();

        n && (e.attrs.nonce = n);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (r) {
        e.setAttribute(r, t[r]);
      });
    }

    function addStyle(e, t) {
      var r, n, a, o;

      if (t.transform && e.css) {
        if (!(o = "function" === typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = o;
      }

      if (t.singleton) {
        var c = l++;
        r = i || (i = createStyleElement(t)), n = applyToSingletonTag.bind(null, r, c, !1), a = applyToSingletonTag.bind(null, r, c, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (r = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), n = function updateLink(e, t, r) {
        var n = r.css,
            a = r.sourceMap,
            o = void 0 === t.convertToAbsoluteUrls && a;
        (t.convertToAbsoluteUrls || o) && (n = s(n));
        a && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */");
        var i = new Blob([n], {
          type: "text/css"
        }),
            l = e.href;
        e.href = URL.createObjectURL(i), l && URL.revokeObjectURL(l);
      }.bind(null, r, t), a = function a() {
        removeStyleElement(r), r.href && URL.revokeObjectURL(r.href);
      }) : (r = createStyleElement(t), n = function applyToTag(e, t) {
        var r = t.css,
            n = t.media;
        n && e.setAttribute("media", n);
        if (e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, r), a = function a() {
        removeStyleElement(r);
      });

      return n(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else a();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var r = listToStyles(e, t);
      return addStylesToDom(r, t), function update(e) {
        for (var a = [], o = 0; o < r.length; o++) {
          var i = r[o];
          (l = n[i.id]).refs--, a.push(l);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (o = 0; o < a.length; o++) {
          var l;

          if (0 === (l = a[o]).refs) {
            for (var c = 0; c < l.parts.length; c++) {
              l.parts[c]();
            }

            delete n[l.id];
          }
        }
      };
    };

    var u = function () {
      var e = [];
      return function (t, r) {
        return e[t] = r, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, r, n) {
      var a = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = u(t, a);else {
        var o = document.createTextNode(a),
            i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(o, i[t]) : e.appendChild(o);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var r = t.protocol + "//" + t.host,
          n = r + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var a,
            o = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (a = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? r + o : n + o.replace(/^\.\//, ""), "url(" + JSON.stringify(a) + ")");
      });
    };
  }, function (e, t, r) {
    "use strict";

    var _Object$freeze;

    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
              n = !0,
              a = !1,
              o = void 0;

          try {
            for (var i, l = e[Symbol.iterator](); !(n = (i = l.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (c) {
            a = !0, o = c;
          } finally {
            try {
              n || null == l.return || l.return();
            } finally {
              if (a) throw o;
            }
          }

          return r;
        }
      }(e, t) || function _unsupportedIterableToArray(e, t) {
        if (e) {
          if ("string" === typeof e) return _arrayLikeToArray(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
        }
      }(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    r.r(t);
    var n = r(0),
        a = r.n(n),
        o = r(2),
        i = r.n(o);

    function __awaiter(e, t, r, n) {
      return new (r || (r = Promise))(function (a, o) {
        function fulfilled(e) {
          try {
            step(n.next(e));
          } catch (t) {
            o(t);
          }
        }

        function rejected(e) {
          try {
            step(n.throw(e));
          } catch (t) {
            o(t);
          }
        }

        function step(e) {
          e.done ? a(e.value) : function adopt(e) {
            return e instanceof r ? e : new r(function (t) {
              t(e);
            });
          }(e.value).then(fulfilled, rejected);
        }

        step((n = n.apply(e, t || [])).next());
      });
    }

    function __generator(e, t) {
      var r,
          n,
          a,
          o,
          i = {
        label: 0,
        sent: function sent() {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
      }, "function" === typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function verb(o) {
        return function (l) {
          return function step(o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; i;) {
              try {
                if (r = 1, n && (a = 2 & o[0] ? n.return : o[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, o[1])).done) return a;

                switch (n = 0, a && (o = [2 & o[0], a.value]), o[0]) {
                  case 0:
                  case 1:
                    a = o;
                    break;

                  case 4:
                    return i.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    i.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = i.ops.pop(), i.trys.pop();
                    continue;

                  default:
                    if (!(a = (a = i.trys).length > 0 && a[a.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      i = 0;
                      continue;
                    }

                    if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                      i.label = o[1];
                      break;
                    }

                    if (6 === o[0] && i.label < a[1]) {
                      i.label = a[1], a = o;
                      break;
                    }

                    if (a && i.label < a[2]) {
                      i.label = a[2], i.ops.push(o);
                      break;
                    }

                    a[2] && i.ops.pop(), i.trys.pop();
                    continue;
                }

                o = t.call(e, i);
              } catch (l) {
                o = [6, l], n = 0;
              } finally {
                r = a = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, l]);
        };
      }
    }

    function __read(e, t) {
      var r = "function" === typeof Symbol && e[Symbol.iterator];
      if (!r) return e;
      var n,
          a,
          o = r.call(e),
          i = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(n = o.next()).done;) {
          i.push(n.value);
        }
      } catch (l) {
        a = {
          error: l
        };
      } finally {
        try {
          n && !n.done && (r = o.return) && r.call(o);
        } finally {
          if (a) throw a.error;
        }
      }

      return i;
    }

    var l = new Map([["avi", "video/avi"], ["gif", "image/gif"], ["ico", "image/x-icon"], ["jpeg", "image/jpeg"], ["jpg", "image/jpeg"], ["mkv", "video/x-matroska"], ["mov", "video/quicktime"], ["mp4", "video/mp4"], ["pdf", "application/pdf"], ["png", "image/png"], ["zip", "application/zip"], ["doc", "application/msword"], ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]]);

    function toFileWithPath(e, t) {
      var r = function withMimeType(e) {
        var t = e.name;

        if (t && -1 !== t.lastIndexOf(".") && !e.type) {
          var r = t.split(".").pop().toLowerCase(),
              n = l.get(r);
          n && Object.defineProperty(e, "type", {
            value: n,
            writable: !1,
            configurable: !1,
            enumerable: !0
          });
        }

        return e;
      }(e);

      if ("string" !== typeof r.path) {
        var n = e.webkitRelativePath;
        Object.defineProperty(r, "path", {
          value: "string" === typeof t ? t : "string" === typeof n && n.length > 0 ? n : e.name,
          writable: !1,
          configurable: !1,
          enumerable: !0
        });
      }

      return r;
    }

    var c = [".DS_Store", "Thumbs.db"];

    function fromEvent(e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (t) {
          return [2, (r = e, r.dataTransfer && e.dataTransfer ? getDataTransferFiles(e.dataTransfer, e.type) : getInputFiles(e))];
          var r;
        });
      });
    }

    function getInputFiles(e) {
      return (function isInput(e) {
        return null !== e;
      }(e.target) && e.target.files ? fromList(e.target.files) : []).map(function (e) {
        return toFileWithPath(e);
      });
    }

    function getDataTransferFiles(e, t) {
      return __awaiter(this, void 0, void 0, function () {
        var r;
        return __generator(this, function (n) {
          switch (n.label) {
            case 0:
              return e.items ? (r = fromList(e.items).filter(function (e) {
                return "file" === e.kind;
              }), "drop" !== t ? [2, r] : [4, Promise.all(r.map(toFilePromises))]) : [3, 2];

            case 1:
              return [2, noIgnoredFiles(flatten(n.sent()))];

            case 2:
              return [2, noIgnoredFiles(fromList(e.files).map(function (e) {
                return toFileWithPath(e);
              }))];
          }
        });
      });
    }

    function noIgnoredFiles(e) {
      return e.filter(function (e) {
        return -1 === c.indexOf(e.name);
      });
    }

    function fromList(e) {
      for (var t = [], r = 0; r < e.length; r++) {
        var n = e[r];
        t.push(n);
      }

      return t;
    }

    function toFilePromises(e) {
      if ("function" !== typeof e.webkitGetAsEntry) return fromDataTransferItem(e);
      var t = e.webkitGetAsEntry();
      return t && t.isDirectory ? fromDirEntry(t) : fromDataTransferItem(e);
    }

    function flatten(e) {
      return e.reduce(function (e, t) {
        return function __spread() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e = e.concat(__read(arguments[t]));
          }

          return e;
        }(e, Array.isArray(t) ? flatten(t) : [t]);
      }, []);
    }

    function fromDataTransferItem(e) {
      var t = e.getAsFile();
      if (!t) return Promise.reject(e + " is not a File");
      var r = toFileWithPath(t);
      return Promise.resolve(r);
    }

    function fromEntry(e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (t) {
          return [2, e.isDirectory ? fromDirEntry(e) : fromFileEntry(e)];
        });
      });
    }

    function fromDirEntry(e) {
      var t = e.createReader();
      return new Promise(function (e, r) {
        var n = [];
        !function readEntries() {
          var a = this;
          t.readEntries(function (t) {
            return __awaiter(a, void 0, void 0, function () {
              var a, o, i;
              return __generator(this, function (l) {
                switch (l.label) {
                  case 0:
                    if (t.length) return [3, 5];
                    l.label = 1;

                  case 1:
                    return l.trys.push([1, 3,, 4]), [4, Promise.all(n)];

                  case 2:
                    return a = l.sent(), e(a), [3, 4];

                  case 3:
                    return o = l.sent(), r(o), [3, 4];

                  case 4:
                    return [3, 6];

                  case 5:
                    i = Promise.all(t.map(fromEntry)), n.push(i), readEntries(), l.label = 6;

                  case 6:
                    return [2];
                }
              });
            });
          }, function (e) {
            r(e);
          });
        }();
      });
    }

    function fromFileEntry(e) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (t) {
          return [2, new Promise(function (t, r) {
            e.file(function (r) {
              var n = toFileWithPath(r, e.fullPath);
              t(n);
            }, function (e) {
              r(e);
            });
          })];
        });
      });
    }

    var s = r(4),
        u = r.n(s);

    function fileAccepted(e, t) {
      return "application/x-moz-file" === e.type || u()(e, t);
    }

    function fileMatchSize(e, t, r) {
      if (isDefined(e.size)) {
        if (isDefined(t) && isDefined(r)) return e.size >= t && e.size <= r;
        if (isDefined(t)) return e.size >= t;
        if (isDefined(r)) return e.size <= r;
      }

      return !0;
    }

    function isDefined(e) {
      return void 0 !== e && null !== e;
    }

    function isPropagationStopped(e) {
      return "function" === typeof e.isPropagationStopped ? e.isPropagationStopped() : "undefined" !== typeof e.cancelBubble && e.cancelBubble;
    }

    function isEvtWithFiles(e) {
      return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function (e) {
        return "Files" === e || "application/x-moz-file" === e;
      }) : !!e.target && !!e.target.files;
    }

    function onDocumentDragOver(e) {
      e.preventDefault();
    }

    function composeEventHandlers() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      return function (e) {
        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
          n[a - 1] = arguments[a];
        }

        return t.some(function (t) {
          return !isPropagationStopped(e) && t && t.apply(void 0, [e].concat(n)), isPropagationStopped(e);
        });
      };
    }

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || function _iterableToArray(e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function es_slicedToArray(e, t) {
      return function es_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function es_iterableToArrayLimit(e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(n = (i = l.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (c) {
          a = !0, o = c;
        } finally {
          try {
            n || null == l.return || l.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }(e, t) || function es_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function ownKeys(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(r, !0).forEach(function (t) {
          _defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(r).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function _defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function _objectWithoutProperties(e, t) {
      if (null == e) return {};

      var r,
          n,
          a = function _objectWithoutPropertiesLoose(e, t) {
        if (null == e) return {};
        var r,
            n,
            a = {},
            o = Object.keys(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
        }

        return a;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (n = 0; n < o.length; n++) {
          r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
        }
      }

      return a;
    }

    var p = Object(n.forwardRef)(function (e, t) {
      var r = e.children,
          o = function useDropzone() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.accept,
            r = e.disabled,
            a = void 0 !== r && r,
            o = e.getFilesFromEvent,
            i = void 0 === o ? fromEvent : o,
            l = e.maxSize,
            c = void 0 === l ? 1 / 0 : l,
            s = e.minSize,
            u = void 0 === s ? 0 : s,
            p = e.multiple,
            d = void 0 === p || p,
            m = e.onDragEnter,
            h = e.onDragLeave,
            v = e.onDragOver,
            y = e.onDrop,
            g = e.onDropAccepted,
            b = e.onDropRejected,
            A = e.onFileDialogCancel,
            E = e.preventDropOnDocument,
            C = void 0 === E || E,
            w = e.noClick,
            _ = void 0 !== w && w,
            F = e.noKeyboard,
            x = void 0 !== F && F,
            k = e.noDrag,
            S = void 0 !== k && k,
            j = e.noDragEventsBubbling,
            D = void 0 !== j && j,
            L = Object(n.useRef)(null),
            O = Object(n.useRef)(null),
            B = es_slicedToArray(Object(n.useReducer)(reducer, f), 2),
            P = B[0],
            T = B[1],
            I = P.isFocused,
            M = P.isFileDialogActive,
            W = P.draggedFiles,
            R = Object(n.useCallback)(function () {
          O.current && (T({
            type: "openDialog"
          }), O.current.value = null, O.current.click());
        }, [T]),
            U = function onWindowFocus() {
          M && setTimeout(function () {
            if (O.current) {
              var e = O.current.files;
              e.length || (T({
                type: "closeDialog"
              }), "function" === typeof A && A());
            }
          }, 300);
        };

        Object(n.useEffect)(function () {
          return window.addEventListener("focus", U, !1), function () {
            window.removeEventListener("focus", U, !1);
          };
        }, [O, M, A]);

        var N = Object(n.useCallback)(function (e) {
          L.current && L.current.isEqualNode(e.target) && (32 !== e.keyCode && 13 !== e.keyCode || (e.preventDefault(), R()));
        }, [L, O]),
            z = Object(n.useCallback)(function () {
          T({
            type: "focus"
          });
        }, []),
            q = Object(n.useCallback)(function () {
          T({
            type: "blur"
          });
        }, []),
            H = Object(n.useCallback)(function () {
          _ || (!function isIeOrEdge() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.navigator.userAgent;
            return function isIe(e) {
              return -1 !== e.indexOf("MSIE") || -1 !== e.indexOf("Trident/");
            }(e) || function isEdge(e) {
              return -1 !== e.indexOf("Edge/");
            }(e);
          }() ? R() : setTimeout(R, 0));
        }, [O, _]),
            G = Object(n.useRef)([]),
            K = function onDocumentDrop(e) {
          L.current && L.current.contains(e.target) || (e.preventDefault(), G.current = []);
        };

        Object(n.useEffect)(function () {
          return C && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", K, !1)), function () {
            C && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", K));
          };
        }, [L, C]);

        var Z = Object(n.useCallback)(function (e) {
          e.preventDefault(), e.persist(), ee(e), -1 === G.current.indexOf(e.target) && (G.current = [].concat(_toConsumableArray(G.current), [e.target])), isEvtWithFiles(e) && Promise.resolve(i(e)).then(function (t) {
            isPropagationStopped(e) && !D || (T({
              draggedFiles: t,
              isDragActive: !0,
              type: "setDraggedFiles"
            }), m && m(e));
          });
        }, [i, m, D]),
            Y = Object(n.useCallback)(function (e) {
          if (e.preventDefault(), e.persist(), ee(e), e.dataTransfer) try {
            e.dataTransfer.dropEffect = "copy";
          } catch (t) {}
          return isEvtWithFiles(e) && v && v(e), !1;
        }, [v, D]),
            $ = Object(n.useCallback)(function (e) {
          e.preventDefault(), e.persist(), ee(e);
          var t = G.current.filter(function (t) {
            return t !== e.target && L.current && L.current.contains(t);
          });
          G.current = t, t.length > 0 || (T({
            isDragActive: !1,
            type: "setDraggedFiles",
            draggedFiles: []
          }), isEvtWithFiles(e) && h && h(e));
        }, [L, h, D]),
            J = Object(n.useCallback)(function (e) {
          e.preventDefault(), e.persist(), ee(e), G.current = [], isEvtWithFiles(e) && Promise.resolve(i(e)).then(function (r) {
            if (!isPropagationStopped(e) || D) {
              var n = [],
                  a = [];
              r.forEach(function (e) {
                fileAccepted(e, t) && fileMatchSize(e, u, c) ? n.push(e) : a.push(e);
              }), !d && n.length > 1 && a.push.apply(a, _toConsumableArray(n.splice(0))), T({
                acceptedFiles: n,
                rejectedFiles: a,
                type: "setFiles"
              }), y && y(n, a, e), a.length > 0 && b && b(a, e), n.length > 0 && g && g(n, e);
            }
          }), T({
            type: "reset"
          });
        }, [d, t, u, c, i, y, g, b, D]),
            X = function composeHandler(e) {
          return a ? null : e;
        },
            V = function composeKeyboardHandler(e) {
          return x ? null : X(e);
        },
            Q = function composeDragHandler(e) {
          return S ? null : X(e);
        },
            ee = function stopPropagation(e) {
          D && e.stopPropagation();
        },
            te = Object(n.useMemo)(function () {
          return function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.refKey,
                r = void 0 === t ? "ref" : t,
                n = e.onKeyDown,
                o = e.onFocus,
                i = e.onBlur,
                l = e.onClick,
                c = e.onDragEnter,
                s = e.onDragOver,
                u = e.onDragLeave,
                p = e.onDrop,
                d = _objectWithoutProperties(e, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

            return _objectSpread(_defineProperty({
              onKeyDown: V(composeEventHandlers(n, N)),
              onFocus: V(composeEventHandlers(o, z)),
              onBlur: V(composeEventHandlers(i, q)),
              onClick: X(composeEventHandlers(l, H)),
              onDragEnter: Q(composeEventHandlers(c, Z)),
              onDragOver: Q(composeEventHandlers(s, Y)),
              onDragLeave: Q(composeEventHandlers(u, $)),
              onDrop: Q(composeEventHandlers(p, J))
            }, r, L), a || x ? {} : {
              tabIndex: 0
            }, {}, d);
          };
        }, [L, N, z, q, H, Z, Y, $, J, x, S, a]),
            re = Object(n.useCallback)(function (e) {
          e.stopPropagation();
        }, []),
            ne = Object(n.useMemo)(function () {
          return function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                r = e.refKey,
                n = void 0 === r ? "ref" : r,
                a = e.onChange,
                o = e.onClick,
                i = _objectWithoutProperties(e, ["refKey", "onChange", "onClick"]),
                l = _defineProperty({
              accept: t,
              multiple: d,
              type: "file",
              style: {
                display: "none"
              },
              onChange: X(composeEventHandlers(a, J)),
              onClick: X(composeEventHandlers(o, re)),
              autoComplete: "off",
              tabIndex: -1
            }, n, O);

            return _objectSpread({}, l, {}, i);
          };
        }, [O, t, d, J, a]),
            ae = W.length,
            oe = ae > 0 && function allFilesAccepted(e) {
          var t = e.files,
              r = e.accept,
              n = e.minSize,
              a = e.maxSize;
          return !(!e.multiple && t.length > 1) && t.every(function (e) {
            return fileAccepted(e, r) && fileMatchSize(e, n, a);
          });
        }({
          files: W,
          accept: t,
          minSize: u,
          maxSize: c,
          multiple: d
        });

        return _objectSpread({}, P, {
          isDragAccept: oe,
          isDragReject: ae > 0 && !oe,
          isFocused: I && !a,
          getRootProps: te,
          getInputProps: ne,
          rootRef: L,
          inputRef: O,
          open: X(R)
        });
      }(_objectWithoutProperties(e, ["children"])),
          i = o.open,
          l = _objectWithoutProperties(o, ["open"]);

      return Object(n.useImperativeHandle)(t, function () {
        return {
          open: i
        };
      }, [i]), a.a.createElement(n.Fragment, null, r(_objectSpread({}, l, {
        open: i
      })));
    });
    p.displayName = "Dropzone", p.propTypes = {
      children: i.a.func,
      accept: i.a.oneOfType([i.a.string, i.a.arrayOf(i.a.string)]),
      multiple: i.a.bool,
      preventDropOnDocument: i.a.bool,
      noClick: i.a.bool,
      noKeyboard: i.a.bool,
      noDrag: i.a.bool,
      noDragEventsBubbling: i.a.bool,
      minSize: i.a.number,
      maxSize: i.a.number,
      disabled: i.a.bool,
      getFilesFromEvent: i.a.func,
      onFileDialogCancel: i.a.func,
      onDragEnter: i.a.func,
      onDragLeave: i.a.func,
      onDragOver: i.a.func,
      onDrop: i.a.func,
      onDropAccepted: i.a.func,
      onDropRejected: i.a.func
    };
    var d = p,
        f = {
      isFocused: !1,
      isFileDialogActive: !1,
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1,
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };

    function reducer(e, t) {
      switch (t.type) {
        case "focus":
          return _objectSpread({}, e, {
            isFocused: !0
          });

        case "blur":
          return _objectSpread({}, e, {
            isFocused: !1
          });

        case "openDialog":
          return _objectSpread({}, e, {
            isFileDialogActive: !0
          });

        case "closeDialog":
          return _objectSpread({}, e, {
            isFileDialogActive: !1
          });

        case "setDraggedFiles":
          var r = t.isDragActive;
          return _objectSpread({}, e, {
            draggedFiles: t.draggedFiles,
            isDragActive: r
          });

        case "setFiles":
          return _objectSpread({}, e, {
            acceptedFiles: t.acceptedFiles,
            rejectedFiles: t.rejectedFiles
          });

        case "reset":
          return _objectSpread({}, e, {
            isFileDialogActive: !1,
            isDragActive: !1,
            draggedFiles: [],
            acceptedFiles: [],
            rejectedFiles: []
          });

        default:
          return e;
      }
    }

    var m = r(5),
        h = r.n(m),
        v = function v(_ref) {
      var e = _ref.className,
          _ref$height = _ref.height,
          t = _ref$height === void 0 ? "98" : _ref$height,
          _ref$width = _ref.width,
          r = _ref$width === void 0 ? "121" : _ref$width;
      return a.a.createElement("svg", {
        className: e,
        width: r,
        height: t,
        viewBox: "0 0 201 163",
        version: "1.1"
      }, a.a.createElement("defs", null, a.a.createElement("polygon", {
        id: "path-1",
        points: "0.767924104 1.0331005 13.284078 1.0331005 13.284078 13.5204332 0.767924104 13.5204332 0.767924104 1.0331005"
      }), a.a.createElement("filter", {
        x: "-6.2%",
        y: "-9.1%",
        width: "112.4%",
        height: "118.2%",
        filterUnits: "objectBoundingBox",
        id: "filter-3"
      }, a.a.createElement("feGaussianBlur", {
        stdDeviation: "3.19999981",
        in: "SourceGraphic"
      }))), a.a.createElement("g", {
        id: "Icons/Illustrations",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, a.a.createElement("g", {
        id: "illustration/csv-success"
      }, a.a.createElement("g", {
        id: "Group-4-Copy",
        transform: "translate(0.000000, 2.000000)"
      }, a.a.createElement("ellipse", {
        id: "Oval-3-Copy",
        fill: "#F8FAFB",
        cx: "105.705179",
        cy: "85.4924623",
        rx: "73.6733068",
        ry: "73.5075377"
      }), a.a.createElement("g", {
        id: "Group-3-Copy",
        transform: "translate(128.928287, 6.391960)"
      }, a.a.createElement("mask", {
        id: "mask-2",
        fill: "white"
      }, a.a.createElement("use", {
        xlinkHref: "#path-1"
      })), a.a.createElement("g", {
        id: "Clip-2"
      }), a.a.createElement("path", {
        d: "M7.85017112,1.64816683 L8.81352968,4.9128603 C8.89641215,5.19210905 9.11502968,5.41143317 9.39490817,5.49293065 L12.6669639,6.45412161 C13.4897827,6.69621709 13.4897827,7.85875477 12.6669639,8.09965176 L9.39490817,9.06084271 C9.11502968,9.1423402 8.89641215,9.36166432 8.81352968,9.64091307 L7.85017112,12.9056065 C7.60873088,13.7253754 6.44357151,13.7253754 6.20093008,12.9056065 L5.23877271,9.64091307 C5.15589024,9.36166432 4.93607151,9.1423402 4.65619303,9.06084271 L1.38413725,8.09965176 C0.562519721,7.85875477 0.562519721,6.69621709 1.38413725,6.45412161 L4.65619303,5.49293065 C4.93607151,5.41143317 5.15589024,5.19210905 5.23877271,4.9128603 L6.20093008,1.64816683 C6.44357151,0.827199497 7.60873088,0.827199497 7.85017112,1.64816683",
        id: "Fill-1",
        fill: "#4D9EFF",
        mask: "url(#mask-2)"
      })), a.a.createElement("path", {
        d: "M5.43816536,89.1601183 L6.17721812,91.6669894 C6.24099425,91.8828623 6.4085629,92.0488224 6.62365101,92.1124613 L9.13593022,92.8511709 C9.76743893,93.0358483 9.76743893,93.9280399 9.13593022,94.1139651 L6.62365101,94.8526748 C6.4085629,94.9150658 6.24099425,95.0822737 6.17721812,95.2968988 L5.43816536,97.8037699 C5.25183902,98.4339192 4.35772273,98.4339192 4.1713964,97.8037699 L3.43234363,95.2968988 C3.36981801,95.0822737 3.20099885,94.9150658 2.98591074,94.8526748 L0.473631533,94.1139651 C-0.157877178,93.9280399 -0.157877178,93.0358483 0.473631533,92.8511709 L2.98591074,92.1124613 C3.20099885,92.0488224 3.36981801,91.8828623 3.43234363,91.6669894 L4.1713964,89.1601183 C4.35772273,88.5312168 5.25183902,88.5312168 5.43816536,89.1601183",
        id: "Fill-4-Copy",
        fill: "#B4C3D8"
      }), a.a.createElement("path", {
        d: "M184.183267,2.39698492 C184.183267,3.72089448 183.107519,4.79396985 181.780313,4.79396985 C180.453106,4.79396985 179.378486,3.72089448 179.378486,2.39698492 C179.378486,1.07307537 180.453106,0 181.780313,0 C183.107519,0 184.183267,1.07307537 184.183267,2.39698492 Z",
        id: "Stroke-6-Copy",
        stroke: "#B4C3D8",
        strokeWidth: "2.39999986",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), a.a.createElement("path", {
        d: "M50.4501992,156.603015 C50.4501992,157.926925 49.3744515,159 48.0483726,159 C46.721166,159 45.6454183,157.926925 45.6454183,156.603015 C45.6454183,155.279106 46.721166,154.20603 48.0483726,154.20603 C49.3744515,154.20603 50.4501992,155.279106 50.4501992,156.603015 Z",
        id: "Stroke-8-Copy",
        stroke: "#4D9EFF",
        strokeWidth: "2.39999986",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), a.a.createElement("path", {
        d: "M201,71.5100503 C201,72.6141302 200.103566,73.5075377 198.997356,73.5075377 C197.89245,73.5075377 196.996016,72.6141302 196.996016,71.5100503 C196.996016,70.4059703 197.89245,69.5125628 198.997356,69.5125628 C200.103566,69.5125628 201,70.4059703 201,71.5100503",
        id: "Fill-10-Copy",
        fill: "#B4C3D8"
      }), a.a.createElement("g", {
        id: "Group",
        transform: "translate(29.000000, 32.000000)"
      }, a.a.createElement("path", {
        d: "M155.354582,26.2041872 L0,26.2041872 L0,11.609073 C0,6.51998712 4.93088757,2.39698492 11.0142676,2.39698492 L144.340314,2.39698492 C150.423694,2.39698492 155.354582,6.51998712 155.354582,11.609073 L155.354582,26.2041872 Z M155.354582,26.2214317 L155.354582,98.6502739 C155.354582,103.73936 150.423694,107.864322 144.340314,107.864322 L11.0142676,107.864322 C4.93088757,107.864322 0,103.73936 0,98.6502739 L0,26.2214317 L155.354582,26.2214317 Z",
        id: "Combined-Shape",
        fill: "#B5D2E1",
        opacity: "0.599999964",
        filter: "url(#filter-3)"
      }), a.a.createElement("rect", {
        id: "Rectangle-6",
        stroke: "#E1EEF4",
        strokeWidth: "0.5",
        fill: "#FFFFFF",
        x: "0.25",
        y: "0.25",
        width: "154.854582",
        height: "104.967337",
        rx: "1.43999983"
      }), a.a.createElement("path", {
        d: "M0.25,7.73994975 L155.104582,7.73994975 L155.104582,1.43999991 C155.104582,0.782781109 154.571801,0.25 153.914582,0.25 L1.43999991,0.25 C0.782781109,0.25 0.25,0.782781109 0.25,1.43999991 L0.25,7.73994975 Z",
        id: "Rectangle-6-Copy",
        stroke: "#E1EEF4",
        strokeWidth: "0.5",
        fill: "#E1EEF4"
      })), a.a.createElement("g", {
        id: "Group-2",
        transform: "translate(36.035857, 45.542714)",
        strokeLinecap: "round",
        strokeWidth: "0.799999952"
      }, a.a.createElement("path", {
        d: "M0.400398406,14.5819095 L139.739044,14.5819095",
        id: "Line-Copy",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,22.5718593 L139.739044,22.5718593",
        id: "Line-Copy-2",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,30.561809 L139.739044,30.561809",
        id: "Line-Copy-3",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,38.5517588 L139.739044,38.5517588",
        id: "Line-Copy-4",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,46.5417085 L139.739044,46.5417085",
        id: "Line-Copy-5",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,54.5316583 L139.739044,54.5316583",
        id: "Line-Copy-6",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,62.521608 L139.739044,62.521608",
        id: "Line-Copy-7",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,70.5115578 L139.739044,70.5115578",
        id: "Line-Copy-8",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,78.5015075 L139.739044,78.5015075",
        id: "Line-Copy-9",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M16.4163347,0.381820607 L16.4163347,85.9096367",
        id: "Line-2",
        stroke: "#E1EEF4"
      }), a.a.createElement("path", {
        d: "M42.0418327,0.381820607 L42.0418327,85.9096367",
        id: "Line-2-Copy",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M67.4669323,0.381820607 L67.4669323,85.9096367",
        id: "Line-2-Copy-2",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M93.0924303,0.381820607 L93.0924303,85.9096367",
        id: "Line-2-Copy-3",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M118.717928,0.381820607 L118.717928,85.9096367",
        id: "Line-2-Copy-4",
        stroke: "#F2F6F8"
      }), a.a.createElement("path", {
        d: "M0.400398406,7.59045226 L139.739044,7.59045226",
        id: "Line",
        stroke: "#E1EEF4"
      })), a.a.createElement("path", {
        d: "M106.5,118 C89.6553151,118 76,104.344685 76,87.5 C76,70.6553151 89.6553151,57 106.5,57 C123.344685,57 137,70.6553151 137,87.5 C137,104.344685 123.344685,118 106.5,118 Z M118.130658,76.7475515 L102.837932,94.0287897 L94.7576096,86.1417004 C93.8905776,85.2986473 92.501012,85.303659 91.6448472,86.1555967 C90.779601,87.0149049 90.7858445,88.4083368 91.6582839,89.2615613 L101.406128,98.7761209 C101.803259,99.1613299 102.352644,99.4040769 102.854385,99.4040769 C103.399903,99.4040769 104.215534,99.1122285 104.617016,98.655927 L121.451513,79.6329977 C122.260251,78.7204222 122.163374,77.3285673 121.236417,76.5335192 C120.316846,75.7462263 118.929229,75.8410594 118.130658,76.7475515 Z",
        id: "Combined-Shape",
        fill: "#13CB6E"
      }), a.a.createElement("g", {
        id: "Group-3",
        transform: "translate(33.633466, 34.356784)",
        fill: "#B5D2E1"
      }, a.a.createElement("ellipse", {
        id: "Oval-3",
        cx: "1.62066022",
        cy: "1.59798995",
        rx: "1.62066022",
        ry: "1.59798995"
      }), a.a.createElement("ellipse", {
        id: "Oval-3-Copy-2",
        cx: "6.80677291",
        cy: "1.59798995",
        rx: "1.62066022",
        ry: "1.59798995"
      }), a.a.createElement("ellipse", {
        id: "Oval-3-Copy-3",
        cx: "11.9928856",
        cy: "1.59798995",
        rx: "1.62066022",
        ry: "1.59798995"
      }))))));
    },
        y = (r(9), r(1)),
        g = r(3);

    r(10);

    var b = "image",
        A = "csv",
        E = "xml",
        C = "pem",
        w = "PDF",
        _ = "video",
        F = "caption",
        x = Object.freeze((_Object$freeze = {}, _defineProperty2(_Object$freeze, b, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-image"
      }, a.a.createElement(g.Icon, {
        name: "cw-image"
      })),
      suppportedFileExtensions: [".png", ".jpg", ".jpeg", ".gif"]
    }), _defineProperty2(_Object$freeze, A, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-csv",
        type: "2"
      }, a.a.createElement(g.Icon, {
        name: "cw-document"
      })),
      suppportedFileExtensions: [".csv"],
      successSrc: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-success-csv",
        type: "2"
      }, a.a.createElement(g.Icon, {
        name: "cw-document-success"
      }))
    }), _defineProperty2(_Object$freeze, E, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-xml-doc"
      }, a.a.createElement(g.Icon, {
        name: "cw-document"
      })),
      suppportedFileExtensions: [".xml"],
      successSrc: a.a.createElement(v, null)
    }), _defineProperty2(_Object$freeze, C, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-pem-doc"
      }, a.a.createElement(g.Icon, {
        name: "cw-document"
      })),
      suppportedFileExtensions: [".pem", ".cert", ".cer", ".crt"],
      successSrc: a.a.createElement(v, null)
    }), _defineProperty2(_Object$freeze, w, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-pdf",
        type: "3"
      }, a.a.createElement(g.Icon, {
        name: "cw-document"
      })),
      suppportedFileExtensions: [".pdf"],
      successSrc: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-pdf",
        type: "3"
      }, a.a.createElement(g.Icon, {
        name: "cw-document-success"
      }))
    }), _defineProperty2(_Object$freeze, _, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-video",
        type: "4"
      }, a.a.createElement(g.Icon, {
        name: "cw-video"
      })),
      suppportedFileExtensions: [".webm", ".mp4", ".gif", ".mov"],
      successSrc: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-video-success",
        type: "4"
      }, a.a.createElement(g.Icon, {
        name: "cw-video-success"
      })),
      maxFileSize: 1e9
    }), _defineProperty2(_Object$freeze, F, {
      placeholderImage: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-pdf",
        type: "3"
      }, a.a.createElement(g.Icon, {
        name: "cw-document"
      })),
      suppportedFileExtensions: [".vtt"],
      successSrc: a.a.createElement(y.ColorWay, {
        className: "tide-upload-area-placeholder-pdf",
        type: "3"
      }, a.a.createElement(g.Icon, {
        name: "cw-document-success"
      }))
    }), _Object$freeze)),
        k = function k(_ref2) {
      var e = _ref2.previewUrl,
          t = _ref2.isLoadingFile,
          r = _ref2.config,
          n = _ref2.type,
          o = _ref2.handleClearFile,
          i = _ref2.onClearFile,
          l = _ref2.previewName,
          c = _ref2.customPlaceholder;

      var s = r.placeholderImage,
          u = r.successSrc,
          p = function () {
        switch (n) {
          case w:
            return "PDF";

          case F:
            return ".vtt";

          default:
            return "file";
        }
      }();

      return t ? a.a.createElement(y.Div, null, a.a.createElement(y.Loader, null), a.a.createElement(y.P, {
        className: "tide-upload-area-loader-copy"
      }, "Loading your file\u2026")) : e ? a.a.createElement(y.Div, {
        className: "tide-upload-area-preview"
      }, n === b && a.a.createElement("img", {
        src: e,
        alt: "previewUrl"
      }), n !== b && l ? a.a.createElement(y.Div, null, u, a.a.createElement(y.P, {
        className: "tide-upload-area-preview-name"
      }, l)) : a.a.createElement(y.Div, null, u), o && a.a.createElement(y.Button, {
        type: "inline-utility",
        className: "tide-anchor-link tide-upload-area-preview-clear-link",
        onClick: i
      }, "Clear")) : a.a.createElement(y.Div, {
        className: "tide-upload-area-placeholder"
      }, c || s, a.a.createElement(y.P, null, "Drag and drop or ", a.a.createElement(y.A, null, "choose a ", p), " to upload"));
    };

    var UploadArea_UploadArea = /*#__PURE__*/function (_n$Component) {
      _inherits(UploadArea_UploadArea, _n$Component);

      var _super = _createSuper(UploadArea_UploadArea);

      function UploadArea_UploadArea(e) {
        var _this;

        _classCallCheck(this, UploadArea_UploadArea);

        _this = _super.call(this, e), _this.saveFileChange = function (e, t) {
          _this.setState({
            isLoadingFile: !1,
            disableClick: !0
          }, _this.props.handleSaveFile(e, t));
        }, _this.clearFile = function (e) {
          var t = _this.props.handleClearFile;

          _this.setState({
            disableClick: !1
          }, t());
        }, _this.handleFile = function (e, t, r) {
          var n = _slicedToArray(e, 1)[0];

          if (!n) {
            return _slicedToArray(t, 1)[0].size >= r ? _this.props.onSizeError() : _this.props.onTypeError();
          }

          var a = Object.assign(n, {
            preview: URL.createObjectURL(n)
          });

          _this.setState({
            isLoadingFile: !0
          }, function () {
            return _this.props.handleUploadFile(a).then(function (e) {
              var t = e.downloadUrl;

              _this.saveFileChange(t, a.name);
            }).catch(function (e) {
              return console.warn(e), _this.setState({
                isLoadingFile: !1
              }, _this.props.onReadError(e));
            });
          });
        }, _this.state = {
          isLoadingFile: !1,
          disableClick: !1
        };
        return _this;
      }

      _createClass(UploadArea_UploadArea, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var e = this.props,
              t = e.type,
              r = e.multiple,
              n = e.className,
              o = e.maxFileSize,
              i = e.previewUrl,
              l = e.disabled,
              c = e.showUpgrade,
              s = this.state,
              u = s.disableClick,
              p = s.isLoadingFile,
              f = x[t],
              m = f.maxFileSize || o,
              v = x[this.props.type].suppportedFileExtensions;
          return a.a.createElement(d, {
            onDrop: function onDrop(e, t) {
              return _this2.handleFile(e, t, m);
            },
            maxSize: m,
            multiple: r,
            disabled: l,
            disableClick: u,
            accept: v
          }, function (_ref3) {
            var e = _ref3.getRootProps,
                t = _ref3.getInputProps;
            return a.a.createElement("section", {
              className: h()("tide-upload-area", {
                empty: !i,
                disabled: l
              }, "".concat(n))
            }, c && a.a.createElement(y.Ribbon, {
              isUpgrade: !0,
              text: "upgrade"
            }), a.a.createElement("div", Object.assign({
              className: "tide-input-wrapper"
            }, e()), a.a.createElement("input", t()), a.a.createElement(k, Object.assign({
              isLoadingFile: p,
              onClearFile: _this2.clearFile,
              config: f
            }, _this2.props))));
          });
        }
      }]);

      return UploadArea_UploadArea;
    }(n.Component);

    UploadArea_UploadArea.defaultProps = {
      type: b,
      multiple: !1,
      maxFileSize: 2e7
    };
    var S = UploadArea_UploadArea;
    r.d(t, "UploadArea", function () {
      return S;
    });
  }]);
});